import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { StepForm, ConfiguratorStepTitleAndDescription } from '@grandvisionhq/configurator';
import { RxEntryRadioTile } from '../../../../../Configurator/components/RxEntryRadioTile/RxEntryRadioTile.js';
import DesktopStepLayout from '../components/DesktopStepLayout/DesktopStepLayout.js';
import { RxStepWrapper } from '../components/RxStepWrapper/RxStepWrapper.js';

const PrescriptionEntrySelectionStep = ({ className , itemsList , selectedEntryItem , onChange , onSubmit ,  })=>{
    const isDesktop = MediaQuery.useIsDesktop();
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: classnames('rx-entry-selection-step', className)
    }, /*#__PURE__*/ React.createElement(DesktopStepLayout, null, /*#__PURE__*/ React.createElement(StepForm, {
        onSubmit: onSubmit,
        className: "rx-entry-selection-step__wrapper"
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: isDesktop ? 'left' : 'center'
    }), /*#__PURE__*/ React.createElement("div", {
        className: "rx-entry-selection-step__entry-list"
    }, /*#__PURE__*/ React.createElement("fieldset", {
        className: "rx-entry-selection-step__list"
    }, itemsList === null || itemsList === void 0 ? void 0 : itemsList.map((item)=>/*#__PURE__*/ React.createElement(RxEntryRadioTile, {
            className: "rx-entry-selection-step__list-item",
            isSelected: selectedEntryItem === item.key,
            onChange: onChange,
            value: item.key,
            key: item.key,
            title: item.title,
            description: item.description,
            iconName: item.icon
        })
    ))))));
};

export { PrescriptionEntrySelectionStep };
//# sourceMappingURL=PrescriptionEntrySelectionStep.js.map
